import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
export const stopPropagation = (event) => {
    event.stopPropagation();
};
export const StopPropagationWrapper = ({ children, sx }) => {
    return (_jsx(Box, Object.assign({ onClick: stopPropagation, sx: sx }, { children: children })));
};
